var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLanguageService = exports.getLanguageServicePlugins = void 0;
const css_1 = require("@volar-plugins/css");
const emmet_1 = require("@volar-plugins/emmet");
const html_1 = require("@volar-plugins/html");
const json_1 = require("@volar-plugins/json");
const pug_1 = require("@volar-plugins/pug");
const typescript_1 = require("@volar-plugins/typescript");
const typescript_twoslash_queries_1 = require("@volar-plugins/typescript-twoslash-queries");
const embedded = require("@volar/language-core");
const embeddedLS = require("@volar/language-service");
const vue = require("@volar/vue-language-core");
const vscode = require("vscode-languageserver-protocol");
const vue_1 = require("./plugins/vue");
const vue_autoinsert_dotvalue_1 = require("./plugins/vue-autoinsert-dotvalue");
const vue_codelens_references_1 = require("./plugins/vue-codelens-references");
const vue_convert_htmlpug_1 = require("./plugins/vue-convert-htmlpug");
const vue_convert_refsugar_1 = require("./plugins/vue-convert-refsugar");
const vue_convert_scriptsetup_1 = require("./plugins/vue-convert-scriptsetup");
const vue_twoslash_queries_1 = require("./plugins/vue-twoslash-queries");
const vue_template_1 = require("./plugins/vue-template");
const pug_beautify_1 = require("@volar-plugins/pug-beautify");
const vue_autoinsert_parentheses_1 = require("./plugins/vue-autoinsert-parentheses");
const vue_autoinsert_space_1 = require("./plugins/vue-autoinsert-space");
function getLanguageServicePlugins(vueCompilerOptions, settings) {
    const tsPlugin = (0, typescript_1.default)();
    const tsPluginPatchAutoImport = (_context, service) => {
        if (!_context.typescript)
            return {};
        const ts = _context.typescript.module;
        const base = tsPlugin(_context, service);
        const autoImportPositions = new WeakSet();
        return Object.assign(Object.assign({}, base), { resolveEmbeddedRange(range) {
                if (autoImportPositions.has(range.start) && autoImportPositions.has(range.end))
                    return range;
            }, complete: Object.assign(Object.assign({}, base.complete), { on(document, position, context) {
                    var _a, _b, _c;
                    return __awaiter(this, void 0, void 0, function* () {
                        const result = yield ((_b = (_a = base.complete) === null || _a === void 0 ? void 0 : _a.on) === null || _b === void 0 ? void 0 : _b.call(_a, document, position, context));
                        if (result) {
                            // filter __VLS_
                            result.items = result.items.filter(item => {
                                var _a;
                                return item.label.indexOf('__VLS_') === -1
                                    && (!((_a = item.labelDetails) === null || _a === void 0 ? void 0 : _a.description) || item.labelDetails.description.indexOf('__VLS_') === -1);
                            });
                            // handle component auto-import patch
                            for (const [_, map] of _context.documents.getMapsByVirtualFileUri(document.uri)) {
                                const virtualFile = (_c = _context.documents.getSourceByUri(map.sourceFileDocument.uri)) === null || _c === void 0 ? void 0 : _c.root;
                                if (virtualFile instanceof vue.VueFile) {
                                    if (map.toSourcePosition(position, data => typeof data.completion === 'object' && !!data.completion.autoImportOnly)) {
                                        result.items.forEach(item => {
                                            item.data.__isComponentAutoImport = true;
                                        });
                                    }
                                }
                            }
                        }
                        return result;
                    });
                },
                resolve(item) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    return __awaiter(this, void 0, void 0, function* () {
                        item = yield base.complete.resolve(item);
                        if (((_a = item.textEdit) === null || _a === void 0 ? void 0 : _a.newText) && /\w*Vue$/.test(item.textEdit.newText)
                            && ((_b = item.additionalTextEdits) === null || _b === void 0 ? void 0 : _b.length) === 1 && item.additionalTextEdits[0].newText.indexOf('import ' + item.textEdit.newText + ' from ') >= 0
                            && ((_d = yield ((_c = _context.env.configurationHost) === null || _c === void 0 ? void 0 : _c.getConfiguration('volar.completion.normalizeComponentImportName'))) !== null && _d !== void 0 ? _d : true)) {
                            let newName = item.textEdit.newText.slice(0, -'Vue'.length);
                            newName = newName[0].toUpperCase() + newName.substring(1);
                            if (newName === 'Index') {
                                const tsItem = item.data.originalItem;
                                if (tsItem.source) {
                                    const dirs = tsItem.source.split('/');
                                    if (dirs.length >= 3) {
                                        newName = dirs[dirs.length - 2];
                                        newName = newName[0].toUpperCase() + newName.substring(1);
                                    }
                                }
                            }
                            item.additionalTextEdits[0].newText = item.additionalTextEdits[0].newText.replace('import ' + item.textEdit.newText + ' from ', 'import ' + newName + ' from ');
                            item.textEdit.newText = newName;
                        }
                        else if (((_e = item.textEdit) === null || _e === void 0 ? void 0 : _e.newText) && /import \w*Vue\$1 from \S*/.test(item.textEdit.newText)
                            && !((_f = item.additionalTextEdits) === null || _f === void 0 ? void 0 : _f.length)) {
                            // https://github.com/johnsoncodehk/volar/issues/2286
                            item.textEdit.newText = item.textEdit.newText.replace('Vue$1', '');
                        }
                        const data = item.data;
                        if (((_g = item.data) === null || _g === void 0 ? void 0 : _g.__isComponentAutoImport) && data && ((_h = item.additionalTextEdits) === null || _h === void 0 ? void 0 : _h.length) && item.textEdit) {
                            for (const [_, map] of _context.documents.getMapsByVirtualFileUri(data.uri)) {
                                const virtualFile = (_j = _context.documents.getSourceByUri(map.sourceFileDocument.uri)) === null || _j === void 0 ? void 0 : _j.root;
                                if (virtualFile instanceof vue.VueFile) {
                                    const sfc = virtualFile.sfc;
                                    const componentName = item.textEdit.newText;
                                    const textDoc = _context.documents.getDocumentByFileName(virtualFile.snapshot, virtualFile.fileName);
                                    if (sfc.scriptAst && sfc.script) {
                                        const _scriptRanges = vue.scriptRanges.parseScriptRanges(ts, sfc.scriptAst, !!sfc.scriptSetup, true);
                                        const exportDefault = _scriptRanges.exportDefault;
                                        if (exportDefault) {
                                            // https://github.com/microsoft/TypeScript/issues/36174
                                            const printer = ts.createPrinter();
                                            if (exportDefault.componentsOption && exportDefault.componentsOptionNode) {
                                                const newNode = Object.assign(Object.assign({}, exportDefault.componentsOptionNode), { properties: [
                                                        ...exportDefault.componentsOptionNode.properties,
                                                        ts.factory.createShorthandPropertyAssignment(componentName),
                                                    ] });
                                                const printText = printer.printNode(ts.EmitHint.Expression, newNode, sfc.scriptAst);
                                                const editRange = vscode.Range.create(textDoc.positionAt(sfc.script.startTagEnd + exportDefault.componentsOption.start), textDoc.positionAt(sfc.script.startTagEnd + exportDefault.componentsOption.end));
                                                autoImportPositions.add(editRange.start);
                                                autoImportPositions.add(editRange.end);
                                                item.additionalTextEdits.push(vscode.TextEdit.replace(editRange, unescape(printText.replace(/\\u/g, '%u'))));
                                            }
                                            else if (exportDefault.args && exportDefault.argsNode) {
                                                const newNode = Object.assign(Object.assign({}, exportDefault.argsNode), { properties: [
                                                        ...exportDefault.argsNode.properties,
                                                        ts.factory.createShorthandPropertyAssignment(`components: { ${componentName} }`),
                                                    ] });
                                                const printText = printer.printNode(ts.EmitHint.Expression, newNode, sfc.scriptAst);
                                                const editRange = vscode.Range.create(textDoc.positionAt(sfc.script.startTagEnd + exportDefault.args.start), textDoc.positionAt(sfc.script.startTagEnd + exportDefault.args.end));
                                                autoImportPositions.add(editRange.start);
                                                autoImportPositions.add(editRange.end);
                                                item.additionalTextEdits.push(vscode.TextEdit.replace(editRange, unescape(printText.replace(/\\u/g, '%u'))));
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        return item;
                    });
                } }), codeAction: Object.assign(Object.assign({}, base.codeAction), { on(document, range, context) {
                    var _a, _b;
                    return __awaiter(this, void 0, void 0, function* () {
                        const result = yield ((_b = (_a = base.codeAction) === null || _a === void 0 ? void 0 : _a.on) === null || _b === void 0 ? void 0 : _b.call(_a, document, range, context));
                        return result === null || result === void 0 ? void 0 : result.filter(codeAction => codeAction.title.indexOf('__VLS_') === -1);
                    });
                } }) });
    };
    // template plugins
    const htmlPlugin = (0, vue_template_1.default)({
        templateLanguagePlugin: (0, html_1.default)(),
        getScanner: (document, htmlPlugin) => {
            return htmlPlugin.getHtmlLs().createScanner(document.getText());
        },
        isSupportedDocument: (document) => document.languageId === 'html',
        vueCompilerOptions,
    });
    const pugPlugin = (0, vue_template_1.default)({
        templateLanguagePlugin: (0, pug_1.default)(),
        getScanner: (document, pugPlugin) => {
            const pugDocument = pugPlugin.getPugDocument(document);
            if (pugDocument) {
                return pugPlugin.getPugLs().createScanner(pugDocument);
            }
        },
        isSupportedDocument: (document) => document.languageId === 'jade',
        vueCompilerOptions,
    });
    return [
        (0, vue_1.default)(vueCompilerOptions),
        (0, css_1.default)(),
        htmlPlugin,
        pugPlugin,
        (0, json_1.default)(settings === null || settings === void 0 ? void 0 : settings.json),
        (0, vue_codelens_references_1.default)(),
        (0, vue_convert_htmlpug_1.default)(),
        (0, vue_convert_scriptsetup_1.default)(vueCompilerOptions),
        (0, vue_convert_refsugar_1.default)(),
        tsPluginPatchAutoImport,
        (0, vue_autoinsert_dotvalue_1.default)(),
        (0, typescript_twoslash_queries_1.default)(),
        (0, vue_twoslash_queries_1.default)(),
        (0, pug_beautify_1.default)(),
        (0, vue_autoinsert_parentheses_1.default)(),
        (0, vue_autoinsert_space_1.default)(),
        // put emmet plugin at last to fix https://github.com/johnsoncodehk/volar/issues/1088
        (0, emmet_1.default)(),
    ];
}
exports.getLanguageServicePlugins = getLanguageServicePlugins;
function createLanguageService(host, env, documentRegistry, settings) {
    const ts = host.getTypeScriptModule();
    const vueCompilerOptions = vue.resolveVueCompilerOptions(host.getVueCompilationSettings());
    const vueLanguageModules = ts ? vue.createLanguageModules(ts, host.getCompilationSettings(), vueCompilerOptions) : [];
    const core = embedded.createLanguageContext(host, vueLanguageModules);
    const languageServiceContext = embeddedLS.createLanguageServiceContext({
        env,
        host,
        context: core,
        documentRegistry,
        getPlugins: () => getLanguageServicePlugins(vueCompilerOptions, settings),
        getLanguageService: () => languageService,
    });
    const languageService = embeddedLS.createLanguageService(languageServiceContext);
    return languageService;
}
exports.createLanguageService = createLanguageService;
//# sourceMappingURL=languageService.js.map